import { createFileRoute } from "@tanstack/react-router";
import ForgotPasswordForm from "@/ui/components/auth/forgot-password";

export const Route = createFileRoute("/_auth/forgot-password")({
  component: ForgotPasswordForm,
});
